<script>
	import { navigate } from "svelte-routing";
	import { Table } from "@sveltestrap/sveltestrap";
	import CustomPaginate from "../../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../../components/Loader/LoaderContainer.svelte";

	export let data;

	//lightbox with image
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";
	import { convert } from "../../../../../services/helpers";

	let modalOpen = false;
	let imageShowingIndex = 0;
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Vehicle No.</th>
				<th>Make</th>
				<th>Model</th>
				<th>Pending</th>
				<th>Last Updated</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { vehicleId, vehicleNumber, vehicleMake, vehicleModel, pendingIssues, lastUpdated }}
				<tr>
					<td>
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p
							class="link"
							on:click={() =>
								navigate(
									`/issue-management/vehicle-issues/details/${vehicleId}?page=1`
								)}
						>
							<span class="link link-text">
								{vehicleNumber}
							</span>
						</p>
					</td>
					<td>
						{vehicleMake}
					</td>
					<td>
						{vehicleModel}
					</td>
					<td>
						<p class="number-bar status-bar-2">{pendingIssues}</p>
					</td>

					<td>
						{lastUpdated == null ? "Null" : convert(lastUpdated)}
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.length} />
</LoaderContainer>
